import React from "react"
import PropTypes from "prop-types"
import Radio from "@material-ui/core/Radio"
import {RadioGroup as MuiRadioGroup} from "@material-ui/core"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormControl from "@material-ui/core/FormControl"
import FormLabel from "@material-ui/core/FormLabel"

const RadioGroup = ({items, title, onChange, defaultValue, disabled}) => (
  <FormControl>
    <FormLabel id="demo-radio-buttons-group-label">{title}</FormLabel>
    <MuiRadioGroup
      onChange={event => onChange(event.target.value)}
      aria-labelledby="demo-radio-buttons-group-label"
      defaultValue={defaultValue}
      name="radio-buttons-group"
    >
      {!!items &&
        items.map(item => (
          <FormControlLabel
            disabled={disabled}
            value={item.value}
            control={<Radio />}
            label={item.label}
          />
        ))}
    </MuiRadioGroup>
  </FormControl>
)

export default RadioGroup

RadioGroup.propTypes = {
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/fields/RadioGroup.js